import { ProductTypes } from '../../../types/ProductType';

export const getGATitle = (productType: number): string => {
  if (productType === ProductTypes.none) {
    return '';
  }

  return ProductTypes[productType] ?? '';
};
